import React from 'react'
import SupplyBillAgreeIco from '../../view/items/SupplyBillAgreeIco'
import Person4Icon from '@mui/icons-material/Person4';
import { useState } from 'react';
import MyModal from '../../../../UI/modal/MyModal';
import AgreeNachBillItemForm from './AgreeNachBillItemForm';

const AgreeNachButton = ({ supplyBillItem }) => {

    const [open, setOpen] = useState(false)

  return (
    <>
        <SupplyBillAgreeIco
            onClick={e => setOpen(true)}
            text={'Погодження начальником постачання'}
            ico={<Person4Icon />}
            value={supplyBillItem.isAgreeSupplyLeader}
        />

        <MyModal
            open={open}
            setOpen={setOpen}
            header={'Погодження'}
            disableClickOutside={true}
            content={
                <AgreeNachBillItemForm
                    // supplyOrderId={supplyOrderId}
                    supplyBillItemBd={supplyBillItem}
                    setOpen={setOpen}
                />
            }
        />
    </>
  )
}

export default AgreeNachButton